import { formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-advt-invoice-register-office-briefly',
  templateUrl: './advt-invoice-register-office-briefly.component.html',
  styleUrl: './advt-invoice-register-office-briefly.component.scss'
})
export class AdvtInvoiceRegisterOfficeBrieflyComponent {


startDate;
      endDate;
      today;
      issueName;
      issueDates;
      reportType;
      advtInvoiceData;
      filteredAdvtInvoiceData : any;
      isLoading = false;
      printShowData = [];
      filteredPrintShowData = [];
      sdate: any;
      enddate: any;
      invoiceNumber: any;
      issuedate: any;
      invoiceName: any;
      advtamount: any;
      discountamt: any;
      netamount: any;
      gstcst: any;
      totalinvoiceamount: any;
      paidamount: any;
      filteredAdvtInvoiceDatamonthly: any;
      netamountm: any;
      advtamountm: any;
      gstcstm: any;
      paidamountm: any;
      filteredAdvtInvoiceDatabrifly: any;
      beforegst: any;
      tcgst: any;
      tsgst: any;
      tigst: any;
      tgst: any;
      totalamount: any;
      cgst: number;
      sgst: number;
      igst: number;
      invoice_total: any;
      additionOfUnpaidAmount: number;
      totalbeforegstamount :number;
      offRepName:any;
      repName:any;
    
      constructor(
        private dialogRef: MatDialogRef<AdvtInvoiceRegisterOfficeBrieflyComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: DigisubservicesService
      ) {}
    
      ngOnInit(): void {
        
        this.isLoading = false;
        this.today = new Date();
        this.startDate = this.data['startDate'];
        this.endDate = this.data['endDate'];
        this.issueName = this.data['issueName'];
        this.issueDates = this.data['issueDates'];
        this.reportType = this.data['reportType'];
        this.sdate = this.data['startDate'];
        this.enddate = this.data['endDate'];
        this.invoiceName = this.data['issueName'];
        this.issuedate = this.data['issueDates'];
        this.offRepName = this.data['off_rep_name'];
        this.repName = this.data['rep_name'];
        // this.advtInvoiceData = this.data['advtData'];
        // console.log(this.data);
    
        console.log(this.sdate, this.enddate, this.invoiceName, this.issuedate, "data");
    
        this.getData();
      }
    additionOfUnpaidAMount:number
     
//       getData() {
        
//    const req: any = {
//       "start_date": this.sdate,
//       "end_date": this.enddate,
//       "issue_name": this.invoiceName,
//       "issue_date": this.issuedate,
//       "rep_name": this.repName?.length ? this.repName : "",
//       "off_rep_name": this.offRepName?.length ? this.offRepName : "",
//   }
// this.service.getAdvtInvoiceRegisterListBriefly(req).subscribe((res: any) => {
//   console.log(res);
//   this.filteredAdvtInvoiceData = res;
  
//   // Initialize all totals to 0
//   this.advtamount = 0;
//   this.discountamt = 0;
//   this.netamount = 0;
//   this.invoice_total = 0;
//   this.cgst = 0;
//   this.sgst = 0;
//   this.igst = 0;
//   this.gstcst = 0;
//   this.totalinvoiceamount = 0;
//   this.paidamount = 0;
//   this.additionOfUnpaidAmount = 0;
//   this.totalbeforegstamount = 0;

//   // Iterate through the groups
//   for (let group of this.filteredAdvtInvoiceData) {
//     // Iterate through the data array in each group
//     for (let data1 of group.data) {
//       console.log(data1.advt_amt, "advt amt");
      
//       // Parse values to float with fallback to 0
//       const advtAmt = parseFloat(data1.advt_amt) || 0;
//       const discountAmt = parseFloat(data1.discount) || 0;
//       const beforegst_amt = parseFloat(data1.beforegst_amt) || 0;
//       const netAmt = parseFloat(data1.net_amt) || 0;
//       const invoiceTotal = parseFloat(data1.invoice_total) || 0;
//       const cgstAmt = parseFloat(data1.cgst) || 0;
//       const sgstAmt = parseFloat(data1.sgst) || 0;
//       const igstAmt = parseFloat(data1.igst) || 0;
//       const gstAmt = parseFloat(data1.gst) || 0;
//       const totalInvoiceAmt = parseFloat(data1.amount) || 0;
//       const paidAmt = parseFloat(data1.received_amt) || 0;
//       const unpaidAmt = parseFloat(data1.unpaid_amount) || 0;
      
//       // Add to totals
//       this.advtamount += advtAmt;
//       this.discountamt += discountAmt;
//       this.netamount += netAmt;
//       this.invoice_total += invoiceTotal;
//       this.cgst += cgstAmt;
//       this.sgst += sgstAmt;
//       this.igst += igstAmt;
//       this.gstcst += gstAmt;
//       this.totalinvoiceamount += totalInvoiceAmt;
//       this.totalbeforegstamount += beforegst_amt;
//       this.paidamount += paidAmt;
//       this.additionOfUnpaidAmount += unpaidAmt;
//     }
//   }
  
//   // Round the totals to 2 decimal places for display
//   this.advtamount = parseFloat(this.advtamount.toFixed(2));
//   this.discountamt = parseFloat(this.discountamt.toFixed(2));
//   this.netamount = parseFloat(this.netamount.toFixed(2));
//   this.invoice_total = parseFloat(this.invoice_total.toFixed(2));
//   this.cgst = parseFloat(this.cgst.toFixed(2));
//   this.sgst = parseFloat(this.sgst.toFixed(2));
//   this.igst = parseFloat(this.igst.toFixed(2));
//   this.gstcst = parseFloat(this.gstcst.toFixed(2));
//   this.totalinvoiceamount = parseFloat(this.totalinvoiceamount.toFixed(2));
//   this.totalbeforegstamount = parseFloat(this.totalbeforegstamount.toFixed(2));
//   this.paidamount = parseFloat(this.paidamount.toFixed(2));
//   this.additionOfUnpaidAmount = parseFloat(this.additionOfUnpaidAmount.toFixed(2));
  
//   console.log(this.advtamount, "total advt");
//   console.log(this.invoice_total, "total invoice");
//   console.log(this.paidamount, "total paid");
// });
    
//         // this.service.getAdvtInvoiceRegisterListmonthly(req).subscribe((res: any) => {
//         //   console.log(res);
//         //   this.filteredAdvtInvoiceDatamonthly = res;
          
          
//         // });
    
       
        
    
//         // this.service.getAdvtInvoiceRegisterListbriefly(req).subscribe((res: any) => {
//         //   console.log(res);
//         //   this.filteredAdvtInvoiceDatabrifly = res;
//         //   this.beforegst = 0;
//         //   this.tcgst =  0;
//         //   this.tsgst =  0;
//         //   this.tigst =  0;
//         //   this.tgst = 0;
//         //   this.totalamount =0;
//         //   for (let data1 of this.filteredAdvtInvoiceDatabrifly) {
           
//         //     this.tcgst += parseInt(data1.cgst) || 0;
//         //     this.tsgst += parseInt(data1.sgst) || 0;
//         //     this.tigst += parseInt(data1.igst) || 0;
//         //     this.tgst += parseInt(data1.gst) || 0;
//         //     this.beforegst += parseInt(data1.beforegst_amt) || 0;
//         //     this.totalamount += parseInt(data1.amount) || 0;
//         // }
//         // });
//       }



getData() {
  const req: any = {
    "start_date": this.sdate,
    "end_date": this.enddate,
    "issue_name": this.invoiceName,
    "issue_date": this.issuedate,
    "rep_name": this.repName?.length ? this.repName : "",
    "off_rep_name": this.offRepName?.length ? this.offRepName : "",
  }

  // this.service.getAdvtInvoiceRegisterListBriefly(req).subscribe((res: any) => {
  //   console.log(res);
  //   this.filteredAdvtInvoiceData = res;
    
  //   // Initialize all totals to 0
  //   this.advtamount = 0;
  //   this.discountamt = 0;
  //   this.netamount = 0;
  //   this.invoice_total = 0;
  //   this.cgst = 0;
  //   this.sgst = 0;
  //   this.igst = 0;
  //   this.gstcst = 0;
  //   this.totalinvoiceamount = 0;
  //   this.paidamount = 0;
  //   this.additionOfUnpaidAmount = 0;
  //   this.totalbeforegstamount = 0;

  //   // Iterate through the groups and calculate rep-wise totals
  //   for (let group of this.filteredAdvtInvoiceData) {
  //     // Initialize group totals
  //     group.rep_advtamount = 0;
  //     group.rep_discountamt = 0;
  //     group.rep_totalbeforegstamount = 0;
  //     group.rep_cgst = 0;
  //     group.rep_sgst = 0;
  //     group.rep_igst = 0;
  //     group.rep_gstcst = 0;
  //     group.rep_invoice_total = 0;
  //     group.rep_paidamount = 0;
  //     group.rep_unpaidamount = 0;

  //     // Iterate through the data array in each group
  //     for (let data1 of group.data) {
  //       console.log(data1.advt_amt, "advt amt");
        
  //       // Parse values to float with fallback to 0
  //       const advtAmt = parseFloat(data1.advt_amt) || 0;
  //       const discountAmt = parseFloat(data1.discount) || 0;
  //       const beforegst_amt = parseFloat(data1.beforegst_amt) || 0;
  //       const netAmt = parseFloat(data1.net_amt) || 0;
  //       const invoiceTotal = parseFloat(data1.invoice_total) || 0;
  //       const cgstAmt = parseFloat(data1.cgst) || 0;
  //       const sgstAmt = parseFloat(data1.sgst) || 0;
  //       const igstAmt = parseFloat(data1.igst) || 0;
  //       const gstAmt = parseFloat(data1.gst) || 0;
  //       const totalInvoiceAmt = parseFloat(data1.amount) || 0;
  //       const paidAmt = parseFloat(data1.received_amt) || 0;
  //       const unpaidAmt = parseFloat(data1.unpaid_amount) || 0;
        
  //       // Add to rep-wise totals
  //       group.rep_advtamount += advtAmt;
  //       group.rep_discountamt += discountAmt;
  //       group.rep_totalbeforegstamount += beforegst_amt;
  //       group.rep_cgst += cgstAmt;
  //       group.rep_sgst += sgstAmt;
  //       group.rep_igst += igstAmt;
  //       group.rep_gstcst += gstAmt;
  //       group.rep_invoice_total += invoiceTotal;
  //       group.rep_paidamount += paidAmt;
  //       group.rep_unpaidamount += unpaidAmt;

  //       // Add to grand totals
  //       this.advtamount += advtAmt;
  //       this.discountamt += discountAmt;
  //       this.netamount += netAmt;
  //       this.invoice_total += invoiceTotal;
  //       this.cgst += cgstAmt;
  //       this.sgst += sgstAmt;
  //       this.igst += igstAmt;
  //       this.gstcst += gstAmt;
  //       this.totalinvoiceamount += totalInvoiceAmt;
  //       this.totalbeforegstamount += beforegst_amt;
  //       this.paidamount += paidAmt;
  //       this.additionOfUnpaidAmount += unpaidAmt;
  //     }

  //     // Round rep-wise totals to 2 decimal places
  //     group.rep_advtamount = parseFloat(group.rep_advtamount.toFixed(2));
  //     group.rep_discountamt = parseFloat(group.rep_discountamt.toFixed(2));
  //     group.rep_totalbeforegstamount = parseFloat(group.rep_totalbeforegstamount.toFixed(2));
  //     group.rep_cgst = parseFloat(group.rep_cgst.toFixed(2));
  //     group.rep_sgst = parseFloat(group.rep_sgst.toFixed(2));
  //     group.rep_igst = parseFloat(group.rep_igst.toFixed(2));
  //     group.rep_gstcst = parseFloat(group.rep_gstcst.toFixed(2));
  //     group.rep_invoice_total = parseFloat(group.rep_invoice_total.toFixed(2));
  //     group.rep_paidamount = parseFloat(group.rep_paidamount.toFixed(2));
  //     group.rep_unpaidamount = parseFloat(group.rep_unpaidamount.toFixed(2));
  //   }
    
  //   // Round the grand totals to 2 decimal places for display
  //   this.advtamount = parseFloat(this.advtamount.toFixed(2));
  //   this.discountamt = parseFloat(this.discountamt.toFixed(2));
  //   this.netamount = parseFloat(this.netamount.toFixed(2));
  //   this.invoice_total = parseFloat(this.invoice_total.toFixed(2));
  //   this.cgst = parseFloat(this.cgst.toFixed(2));
  //   this.sgst = parseFloat(this.sgst.toFixed(2));
  //   this.igst = parseFloat(this.igst.toFixed(2));
  //   this.gstcst = parseFloat(this.gstcst.toFixed(2));
  //   this.totalinvoiceamount = parseFloat(this.totalinvoiceamount.toFixed(2));
  //   this.totalbeforegstamount = parseFloat(this.totalbeforegstamount.toFixed(2));
  //   this.paidamount = parseFloat(this.paidamount.toFixed(2));
  //   this.additionOfUnpaidAmount = parseFloat(this.additionOfUnpaidAmount.toFixed(2));
    
  //   console.log(this.advtamount, "total advt");
  //   console.log(this.invoice_total, "total invoice");
  //   console.log(this.paidamount, "total paid");
  // });

this.service.getAdvtInvoiceRegisterListBriefly(req).subscribe((res: any) => {
  console.log(res);
  this.filteredAdvtInvoiceData = res;
  
  // Initialize all totals to 0
  this.advtamount = 0;
  this.discountamt = 0;
  this.netamount = 0;
  this.invoice_total = 0;
  this.cgst = 0;
  this.sgst = 0;
  this.igst = 0;
  this.gstcst = 0;
  this.totalinvoiceamount = 0;
  this.paidamount = 0;
  this.additionOfUnpaidAmount = 0;
  this.totalbeforegstamount = 0;

  // Iterate through the office representative groups
  for (let officeGroup of this.filteredAdvtInvoiceData) {
    // Initialize office representative totals
    officeGroup.office_advt_amt = 0;
    officeGroup.office_discount = 0;
    officeGroup.office_beforegst_amt = 0;
    officeGroup.office_cgst = 0;
    officeGroup.office_sgst = 0;
    officeGroup.office_igst = 0;
    officeGroup.office_gst = 0;
    officeGroup.office_invoice_total = 0;
    officeGroup.office_paid_amt = 0;
    officeGroup.office_unpaid_amt = 0;

    // Iterate through representatives under this office representative
    for (let repGroup of officeGroup.representatives) {
      // Initialize representative-wise totals
      repGroup.rep_advt_amt = 0;
      repGroup.rep_discount = 0;
      repGroup.rep_beforegst_amt = 0;
      repGroup.rep_cgst = 0;
      repGroup.rep_sgst = 0;
      repGroup.rep_igst = 0;
      repGroup.rep_gst = 0;
      repGroup.rep_invoice_total = 0;
      repGroup.rep_paid_amt = 0;
      repGroup.rep_unpaid_amt = 0;

      // Iterate through the data array in each representative group
      for (let data1 of repGroup.data) {
        console.log(data1.advt_amt, "advt amt");
        
        // Parse values to float with fallback to 0
        const advtAmt = parseFloat(data1.advt_amt) || 0;
        const discountAmt = parseFloat(data1.discount) || 0;
        const beforegst_amt = parseFloat(data1.beforegst_amt) || 0;
        const netAmt = parseFloat(data1.net_amt) || 0;
        const invoiceTotal = parseFloat(data1.invoice_total) || 0;
        const cgstAmt = parseFloat(data1.cgst) || 0;
        const sgstAmt = parseFloat(data1.sgst) || 0;
        const igstAmt = parseFloat(data1.igst) || 0;
        const gstAmt = parseFloat(data1.gst) || 0;
        const totalInvoiceAmt = parseFloat(data1.amount) || 0;
        const paidAmt = parseFloat(data1.received_amt) || 0;
        const unpaidAmt = parseFloat(data1.unpaid_amount) || 0;
        
        // Add to representative totals
        repGroup.rep_advt_amt += advtAmt;
        repGroup.rep_discount += discountAmt;
        repGroup.rep_beforegst_amt += beforegst_amt;
        repGroup.rep_cgst += cgstAmt;
        repGroup.rep_sgst += sgstAmt;
        repGroup.rep_igst += igstAmt;
        repGroup.rep_gst += gstAmt;
        repGroup.rep_invoice_total += invoiceTotal;
        repGroup.rep_paid_amt += paidAmt;
        repGroup.rep_unpaid_amt += unpaidAmt;

        // Add to office representative totals
        officeGroup.office_advt_amt += advtAmt;
        officeGroup.office_discount += discountAmt;
        officeGroup.office_beforegst_amt += beforegst_amt;
        officeGroup.office_cgst += cgstAmt;
        officeGroup.office_sgst += sgstAmt;
        officeGroup.office_igst += igstAmt;
        officeGroup.office_gst += gstAmt;
        officeGroup.office_invoice_total += invoiceTotal;
        officeGroup.office_paid_amt += paidAmt;
        officeGroup.office_unpaid_amt += unpaidAmt;

        // Add to grand totals
        this.advtamount += advtAmt;
        this.discountamt += discountAmt;
        this.netamount += netAmt;
        this.invoice_total += invoiceTotal;
        this.cgst += cgstAmt;
        this.sgst += sgstAmt;
        this.igst += igstAmt;
        this.gstcst += gstAmt;
        this.totalinvoiceamount += totalInvoiceAmt;
        this.totalbeforegstamount += beforegst_amt;
        this.paidamount += paidAmt;
        this.additionOfUnpaidAmount += unpaidAmt;
      }

      // Round representative totals to 2 decimal places
      repGroup.rep_advt_amt = parseFloat(repGroup.rep_advt_amt.toFixed(2));
      repGroup.rep_discount = parseFloat(repGroup.rep_discount.toFixed(2));
      repGroup.rep_beforegst_amt = parseFloat(repGroup.rep_beforegst_amt.toFixed(2));
      repGroup.rep_cgst = parseFloat(repGroup.rep_cgst.toFixed(2));
      repGroup.rep_sgst = parseFloat(repGroup.rep_sgst.toFixed(2));
      repGroup.rep_igst = parseFloat(repGroup.rep_igst.toFixed(2));
      repGroup.rep_gst = parseFloat(repGroup.rep_gst.toFixed(2));
      repGroup.rep_invoice_total = parseFloat(repGroup.rep_invoice_total.toFixed(2));
      repGroup.rep_paid_amt = parseFloat(repGroup.rep_paid_amt.toFixed(2));
      repGroup.rep_unpaid_amt = parseFloat(repGroup.rep_unpaid_amt.toFixed(2));
    }

    // Round office representative totals to 2 decimal places
    officeGroup.office_advt_amt = parseFloat(officeGroup.office_advt_amt.toFixed(2));
    officeGroup.office_discount = parseFloat(officeGroup.office_discount.toFixed(2));
    officeGroup.office_beforegst_amt = parseFloat(officeGroup.office_beforegst_amt.toFixed(2));
    officeGroup.office_cgst = parseFloat(officeGroup.office_cgst.toFixed(2));
    officeGroup.office_sgst = parseFloat(officeGroup.office_sgst.toFixed(2));
    officeGroup.office_igst = parseFloat(officeGroup.office_igst.toFixed(2));
    officeGroup.office_gst = parseFloat(officeGroup.office_gst.toFixed(2));
    officeGroup.office_invoice_total = parseFloat(officeGroup.office_invoice_total.toFixed(2));
    officeGroup.office_paid_amt = parseFloat(officeGroup.office_paid_amt.toFixed(2));
    officeGroup.office_unpaid_amt = parseFloat(officeGroup.office_unpaid_amt.toFixed(2));
  }
  
  // Round the grand totals to 2 decimal places for display
  this.advtamount = parseFloat(this.advtamount.toFixed(2));
  this.discountamt = parseFloat(this.discountamt.toFixed(2));
  this.netamount = parseFloat(this.netamount.toFixed(2));
  this.invoice_total = parseFloat(this.invoice_total.toFixed(2));
  this.cgst = parseFloat(this.cgst.toFixed(2));
  this.sgst = parseFloat(this.sgst.toFixed(2));
  this.igst = parseFloat(this.igst.toFixed(2));
  this.gstcst = parseFloat(this.gstcst.toFixed(2));
  this.totalinvoiceamount = parseFloat(this.totalinvoiceamount.toFixed(2));
  this.totalbeforegstamount = parseFloat(this.totalbeforegstamount.toFixed(2));
  this.paidamount = parseFloat(this.paidamount.toFixed(2));
  this.additionOfUnpaidAmount = parseFloat(this.additionOfUnpaidAmount.toFixed(2));
  
  console.log(this.advtamount, "total advt");
  console.log(this.invoice_total, "total invoice");
  console.log(this.paidamount, "total paid");
});


}
    
      filterData() {
        // console.log('called');
        if (this.startDate == '' && this.endDate == '') {
          this.advtInvoiceData = this.filteredAdvtInvoiceData;
          // console.log('filteredData', this.advtInvoiceData);
        } else if (this.startDate !== '' && this.endDate !== '') {
          this.advtInvoiceData = this.filteredAdvtInvoiceData.filter((a) => {
            return (
              a['invoice_date'] >= this.startDate &&
              a['invoice_date'] <= this.endDate
            );
          });
          // console.log('filteredData', this.advtInvoiceData);
        }
    
        setTimeout(() => {
          this.setData();
        }, 700);
      }
    
      uniqueid(data, key) {
        return [...new Map(data.map((x) => [key(x), x])).values()];
      }
    
      setData() {
        // console.log(this.advtInvoiceData);
        // console.log(this.advtInvoiceData);
        if (this.advtInvoiceData.length == 0) {
          this.isLoading = false;
          alert('Data is not Present.');
          this.dialogRef.close();
        }
        let data = this.uniqueid(this.advtInvoiceData, (a) => a.advt_name);
        // console.log(data);
        for (let index = 0; index < this.advtInvoiceData.length; index++) {
          // let eachData = this.advtInvoiceData.filter(
          //   (a) => data[i]['advt_name'] == a.advt_name
          // );
    
          let showData = {
            issue_name: '',
            invoice_no: '',
            invoice_date: '',
            advt_name: '',
            client_name: '',
            rep_name: '',
            off_rep_name: '',
            firstweek_issue_date: '',
            secondweek_issue_date: '',
            thirdweek_issue_date: '',
            fourthweek_issue_date: '',
            fifthweek_issue_date: '',
            total_advt_amt: 0,
            total_dis: 0,
            total_net: 0,
            total_cgst: 0,
            total_sgst: 0,
            total_igst: 0,
            total_amt: 0,
          };
    
          // if (Object.keys(eachData).length > 0) {
          console.log('called', this.advtInvoiceData);
          // for (let index = 0; index < this.advtInvoiceData.length; index++) {
          if (
            this.advtInvoiceData[index]['first_week_id'] != null &&
            this.advtInvoiceData[index]['first_week_issue_name'] ===
              this.issueName &&
            this.issueDates.includes(
              this.advtInvoiceData[index]['first_week_date']
            )
          ) {
            console.log('first');
            showData['issue_name'] =
              this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
              console.log(  showData['issue_name'], "new issue name");
    
            showData['firstweek_issue_date'] =
              this.advtInvoiceData[index]['first_week_issue_date'].split(',')[0];
            showData['total_advt_amt'] += parseInt(
              this.advtInvoiceData[index]['first_week_advt_amt']
            );
            showData['total_dis'] += parseInt(
              this.advtInvoiceData[index]['first_week_advt_discnt']
            );
            showData['total_net'] += parseInt(
              this.advtInvoiceData[index]['first_week_amount']
            );
            showData['total_cgst'] += parseInt(
              this.advtInvoiceData[index]['first_week_cgst']
            );
            showData['total_sgst'] += parseInt(
              this.advtInvoiceData[index]['first_week_sgst']
            );
            showData['total_igst'] += parseInt(
              this.advtInvoiceData[index]['first_week_igst']
            );
            showData['total_amt'] += parseInt(
              this.advtInvoiceData[index]['first_week_total_amount']
            );
          } else if (
            this.advtInvoiceData[index]['second_week_id'] != null &&
            this.advtInvoiceData[index]['second_week_issue_name'] ===
              this.issueName &&
            this.issueDates.includes(
              this.advtInvoiceData[index]['second_week_date']
            )
          ) {
            debugger
            showData['issue_name'] =
              this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
            showData['secondweek_issue_date'] =
              this.advtInvoiceData[index]['second_week_issue_date'].split(',')[0];
            showData['total_advt_amt'] += parseInt(
              this.advtInvoiceData[index]['second_week_advt_amt']
            );
            showData['total_dis'] += parseInt(
              this.advtInvoiceData[index]['second_week_advt_discnt']
            );
            showData['total_net'] += parseInt(
              this.advtInvoiceData[index]['second_week_amount']
            );
            showData['total_cgst'] += parseInt(
              this.advtInvoiceData[index]['second_week_cgst']
            );
            showData['total_sgst'] += parseInt(
              this.advtInvoiceData[index]['second_week_sgst']
            );
            showData['total_igst'] += parseInt(
              this.advtInvoiceData[index]['second_week_igst']
            );
            showData['total_amt'] += parseInt(
              this.advtInvoiceData[index]['second_week_total_amount']
            );
          } else if (
            this.advtInvoiceData[index]['third_week_id'] != null &&
            this.advtInvoiceData[index]['third_week_issue_name'] ===
              this.issueName &&
            this.issueDates.includes(
              this.advtInvoiceData[index]['third_week_date']
            )
          ) {
            showData['issue_name'] =
              this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
            showData['thirdweek_issue_date'] =
              this.advtInvoiceData[index]['third_week_issue_date'].split(',')[0];
            showData['total_advt_amt'] += parseInt(
              this.advtInvoiceData[index]['third_week_advt_amt']
            );
            showData['total_dis'] += parseInt(
              this.advtInvoiceData[index]['third_week_advt_discnt']
            );
            showData['total_net'] += parseInt(
              this.advtInvoiceData[index]['third_week_amount']
            );
            showData['total_cgst'] += parseInt(
              this.advtInvoiceData[index]['third_week_cgst']
            );
            showData['total_sgst'] += parseInt(
              this.advtInvoiceData[index]['third_week_sgst']
            );
            showData['total_igst'] += parseInt(
              this.advtInvoiceData[index]['third_week_igst']
            );
            showData['total_amt'] += parseInt(
              this.advtInvoiceData[index]['third_week_total_amount']
            );
          } else if (
            this.advtInvoiceData[index]['fourth_week_id'] != null &&
            this.advtInvoiceData[index]['fourth_week_issue_name'] ===
              this.issueName &&
            this.issueDates.includes(
              this.advtInvoiceData[index]['fourth_week_date']
            )
          ) {
            showData['issue_name'] =
              this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
            showData['fourthweek_issue_date'] =
              this.advtInvoiceData[index]['fourth_week_issue_date'].split(',')[0];
            showData['total_advt_amt'] += parseInt(
              this.advtInvoiceData[index]['fourth_week_advt_amt']
            );
            showData['total_dis'] += parseInt(
              this.advtInvoiceData[index]['fourth_week_advt_discnt']
            );
            showData['total_net'] += parseInt(
              this.advtInvoiceData[index]['fourth_week_amount']
            );
            showData['total_cgst'] += parseInt(
              this.advtInvoiceData[index]['fourth_week_cgst']
            );
            showData['total_sgst'] += parseInt(
              this.advtInvoiceData[index]['fourth_week_sgst']
            );
            showData['total_igst'] += parseInt(
              this.advtInvoiceData[index]['fourth_week_igst']
            );
            showData['total_amt'] += parseInt(
              this.advtInvoiceData[index]['fourth_week_total_amount']
            );
          } else if (
            this.advtInvoiceData[index]['fifth_week_id'] != null &&
            this.advtInvoiceData[index]['fifth_week_issue_name'] ===
              this.issueName &&
            this.issueDates.includes(
              this.advtInvoiceData[index]['fifth_week_date']
            )
          ) {
            showData['issue_name'] =
              this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
            showData['fifthweek_issue_date'] =
              this.advtInvoiceData[index]['fifth_week_issue_date'].split(',')[0];
            showData['total_advt_amt'] += parseInt(
              this.advtInvoiceData[index]['fifth_week_advt_amt']
            );
            showData['total_dis'] += parseInt(
              this.advtInvoiceData[index]['fifth_week_advt_discnt']
            );
            showData['total_net'] += parseInt(
              this.advtInvoiceData[index]['fifth_week_amount']
            );
            showData['total_cgst'] += parseInt(
              this.advtInvoiceData[index]['fifth_week_cgst']
            );
            showData['total_sgst'] += parseInt(
              this.advtInvoiceData[index]['fifth_week_sgst']
            );
            showData['total_igst'] += parseInt(
              this.advtInvoiceData[index]['fifth_week_igst']
            );
            showData['total_amt'] += parseInt(
              this.advtInvoiceData[index]['fifth_week_total_amount']
            );
          }
          // }
          if (
            (this.advtInvoiceData[index]['first_week_issue_name'] ===
              this.issueName &&
              this.issueDates.includes(
                this.advtInvoiceData[index]['first_week_issue_date']
              )) ||
            (this.advtInvoiceData[index]['second_week_issue_name'] ===
              this.issueName &&
              this.issueDates.includes(
                this.advtInvoiceData[index]['second_week_issue_date']
              )) ||
            (this.advtInvoiceData[index]['third_week_issue_name'] ===
              this.issueName &&
              this.issueDates.includes(
                this.advtInvoiceData[index]['third_week_issue_date']
              )) ||
            (this.advtInvoiceData[index]['fourth_week_issue_name'] ===
              this.issueName &&
              this.issueDates.includes(
                this.advtInvoiceData[index]['fourth_week_issue_date']
              )) ||
            (this.advtInvoiceData[index]['fifth_week_issue_name'] ===
              this.issueName &&
              this.issueDates.includes(
                this.advtInvoiceData[index]['fifth_week_issue_date']
              ))
          ) {
            showData['invoice_no'] = this.advtInvoiceData[0]['invoice_no'];
            showData['invoice_date'] = this.advtInvoiceData[0]['invoice_date'];
            showData['advt_name'] = this.advtInvoiceData[0]['advt_name'];
            showData['client_name'] = this.advtInvoiceData[0]['cust_name'];
            showData['rep_name'] = this.advtInvoiceData[0]['rep_name'];
            showData['off_rep_name'] = this.advtInvoiceData[0]['off_rep_name'];
    
            this.printShowData.push(showData);
          }
    
          // console.log('showData', showData);
          // }
          console.log('printShowData', this.printShowData);
          if (index == data.length - 1) {
            this.isLoading = false;
            this.filterPrintShowData();
          }
        }
      }
    
      filterPrintShowData() {
        let data = this.uniqueid(this.printShowData, (a) =>
          formatDate(a.invoice_date, 'MM', 'en-IN', 'GMT+0530')
        );
        // console.log(data);
        let totalAdvtAmt1 = 0;
        let totalDisAmt1 = 0;
        let totalNetAmt1 = 0;
        let totalCGST1 = 0;
        let totalSGST1 = 0;
        let totalIGST1 = 0;
        let totalInvoiceAmount1 = 0;
        for (let index = 0; index < data.length; index++) {
          let filteredData = this.printShowData.filter((a) => {
            return (
              formatDate(a.invoice_date, 'MM', 'en-IN', 'GMT+0530') ==
              formatDate(data[index]['invoice_date'], 'MM', 'en-IN', 'GMT+0530')
            );
          });
          // console.log(filteredData);
          let totalAdvtAmt = 0;
          let totalDisAmt = 0;
          let totalNetAmt = 0;
          let totalCGST = 0;
          let totalSGST = 0;
          let totalIGST = 0;
          let totalInvoiceAmount = 0;
          let issue_date = '';
          for (let i = 0; i < filteredData.length; i++) {
            totalAdvtAmt += parseInt(filteredData[index]['total_advt_amt']);
            totalDisAmt += parseInt(filteredData[index]['total_dis']);
            totalNetAmt += parseInt(filteredData[index]['total_net']);
            totalCGST += parseInt(filteredData[index]['total_cgst']);
            totalSGST += parseInt(filteredData[index]['total_sgst']);
            totalIGST += parseInt(filteredData[index]['total_igst']);
            totalInvoiceAmount += parseInt(filteredData[index]['total_amt']);
            issue_date = filteredData[index]['invoice_date'];
          }
    
          filteredData.push({
            issue_date,
            totalAdvtAmt,
            totalDisAmt,
            totalNetAmt,
            totalCGST,
            totalSGST,
            totalIGST,
            totalInvoiceAmount,
          });
    
          totalAdvtAmt1 += totalAdvtAmt;
          totalDisAmt1 += totalDisAmt;
          totalNetAmt1 += totalNetAmt;
          totalCGST1 += totalCGST;
          totalSGST1 += totalSGST;
          totalIGST1 += totalIGST;
          totalInvoiceAmount1 = totalInvoiceAmount;
    
          this.filteredPrintShowData.push(filteredData);
        }
    
        this.filteredPrintShowData.push({
          totalAdvtAmt1,
          totalDisAmt1,
          totalNetAmt1,
          totalCGST1,
          totalSGST1,
          totalIGST1,
          totalInvoiceAmount1,
        });
    
        console.log(this.filteredPrintShowData);
      }
    
      exportExcel(fileName) {
        /* table id is passed over here */
        let element = document.getElementById('print-section');
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
        /* save to file */
        XLSX.writeFile(wb, fileName + '.xlsx');
      }
    
      issuedatereturn(dates){
        if(dates!=null){
          let returnissuedate = dates.split(',');
          return returnissuedate[0];
        }else{
          return null;
        }
      
      }
      
     show = false

  
  printPage() {
      this.show = true;
      const printSection = document.getElementById('print-section1');
      if (!printSection) {
          console.error("Print section not found!");
          return;
      }
    
      const printContent = printSection.innerHTML;
    
      const screenWidth = window.screen.availWidth;
  
      const windowWidth = 1000;
      const leftPosition = screenWidth - windowWidth - 50;
    
      const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
    
      
      if (printWindow) {
          printWindow.document.open();
          printWindow.document.write(`
              <html>
                  <head>
                      <title>Print Report</title>
                      <style>
                          @media print {
                              @page {
                                  size: A3 landscape;
                                  margin: 5mm;
                              }
                              body {
                                  font-family: Arial, sans-serif;
                                  margin: 0;
                                  padding: 0;
                                  font-size: 14px !important;
                              }
                              .print-section {
                                  width: 100%;
                                  margin: 0 auto;
                                  padding: 0;
                              }
                              table {
                                  width: auto !important;
                                  border-collapse: collapse;
                                  table-layout: auto;
                                  page-break-inside: auto;
                                  border: 2px solid black !important; /* Thicker outer border */
                              }
                              tr {
                                  page-break-inside: avoid;
                                  page-break-after: auto;
                              }
                              th, td {
                                  padding: 2px 3px !important;
                                  border: 1px solid black !important;
                                  font-size: 14px;
                                  line-height: 1.2;
                                  white-space: nowrap;
                              }
                              /* Ensure the rightmost column has a proper right border */
                              tr td:last-child,
                              tr th:last-child {
                                  border-right: 2px solid black !important;
                              }
                              /* Ensure the top row has proper top border */
                              tr:first-child td,
                              tr:first-child th {
                                  border-top: 2px solid black !important;
                              }
                              /* Ensure the leftmost column has proper left border */
                              tr td:first-child,
                              tr th:first-child {
                                  border-left: 2px solid black !important;
                              }
                              /* Ensure the bottom row has proper bottom border */
                              tr:last-child td,
                              tr:last-child th {
                                  border-bottom: 2px solid black !important;
                              }
                              th {
                                  background-color: #f2f2f2;
                                  font-weight: bold;
                              }
                              tr {
                                  border-bottom: 1px solid black !important;
                              }
                              tr.header-row {
                                  display: table-header-group;
                              }
                              td[data-type="number"],
                              td.amount,
                              td.balance-value,
                              td:nth-child(n+12) {
                                  text-align: end !important;
                              }
                              td.text,
                              td[data-type="string"] {
                                  text-align: left !important;
                              }
                              .br-right { border-right: 1px solid black !important; }
                              .br-rightt { border-right: 1px solid black !important; }
                              .br-bottom { border-bottom: 1px solid black !important; }
                              .br-top { border-top: 1px solid black !important; }
                              .noPrint { display: none !important; }
                              .footer-line {
                                  position: fixed;
                                  bottom: 0;
                                  left: 0;
                                  width: 100%;
                                  height: 1px;
                                  background-color: black;
                              }
                              thead { 
                                  display: table-header-group; 
                                  border: 2px solid black !important;
                              }
                              tfoot { 
                                  display: table-footer-group; 
                                  border: 2px solid black !important;
                              }
                              /* Ensure all borders are displayed */
                              table, th, td {
                                  border-style: solid !important;
                                  border-width: 1px !important;
                                  border-color: black !important;
                              }
                              /* Make sure header repeats on each page */
                              thead tr {
                                  display: table-row !important;
                              }
                          }
                      </style>
                  </head>
                  <body>
                      <div class="print-section">
                          ${printContent}
                          <div class="footer-line"></div>
                      </div>
                      <script>
                         window.onload = function () {
                             const table = document.querySelector('table');
                             if (!table) {
                                 console.error("Table not found");
                                 return;
                             }
  
                             // Auto-size columns based on content
                             table.style.width = 'auto';
                             const cols = table.querySelectorAll('td, th');
                             cols.forEach(cell => {
                                 cell.style.width = 'auto';
                                 cell.style.whiteSpace = 'nowrap';
                             });
  
                             let headerRowIndex = -1;
                             const maxRowsToCheck = Math.min(10, table.rows.length);
  
                             // Find header row with column names
                             for (let i = 0; i < maxRowsToCheck; i++) {
                                 const row = table.rows[i];
                                 const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
  
                                 if (row.cells.length >= 8 &&
                                     (cellTexts.includes('Invoice No') ||
                                      cellTexts.includes('Receipt No') ||
                                      cellTexts.includes('Balance'))) {
                                     headerRowIndex = i;
                                     break;
                                 }
                             }
  
                             if (headerRowIndex >= 0) {
                                 // Create thead and move only the actual header row into it
                                 let thead = table.querySelector('thead');
                                 if (!thead) {
                                     thead = document.createElement('thead');
                                     table.insertBefore(thead, table.firstChild);
                                 }
  
                                 const headerRow = table.rows[headerRowIndex];
                                 thead.appendChild(headerRow.cloneNode(true));
                             }
  
                             // Alignment processing
                             const cells = document.querySelectorAll('td');
                             cells.forEach(cell => {
                                 const content = cell.textContent.trim();
  
                                 if (content.includes('येणे') ||
                                     content.includes('Opening Balance') ||
                                     content.match(/^\\d+\\s+येणे$/) ||
                                     content.includes('Balance C/F') ||
                                     content.includes('Total')) {
                                     cell.style.textAlign = 'right';
                                     cell.classList.add('balance-value');
                                 }
  
                                 const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
                                 if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
                                     cell.style.textAlign = 'right';
                                     cell.classList.add('amount');
                                 }
  
                                 cell.style.border = '1px solid black';
                             });
  
                             // Force outer border on table after all processing
                             setTimeout(() => {
                                 table.style.border = '2px solid black';
                                 
                                 // Ensure rightmost cells have thick right border
                                 const rows = table.querySelectorAll('tr');
                                 rows.forEach(row => {
                                     const lastCell = row.querySelector('td:last-child, th:last-child');
                                     if (lastCell) {
                                         lastCell.style.borderRight = '2px solid black';
                                     }
                                 });
                                 
                             }, 100);
  
                             setTimeout(() => {
                                 window.print();
                                 setTimeout(() => { window.close(); }, 500);
                             }, 200);
                         };
                      </script>
                  </body>
              </html>
          `);
          printWindow.document.close();
      } else {
          console.error("Failed to open print window.");
      }
  }

  closeexp(): void {
    this.dialogRef.close();
  }
  
}
